export const getUserDisplayName = (user) => {
    if (!user)
        return "Utilisateur inconnu";
    const fromName = user.name?.trim();
    const fromParts = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
    const fullName = fromName || fromParts;
    if (fullName)
        return fullName;
    if (user.email)
        return user.email;
    if (typeof user.id === "number")
        return `ID #${user.id}`;
    return "Utilisateur inconnu";
};
export default getUserDisplayName;
